"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _freeze = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/freeze"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _CancellationTokenSource = _interopRequireDefault(require("./CancellationTokenSource"));

var _CancelError = _interopRequireDefault(require("./CancelError"));

// eslint-disable-next-line import/no-cycle

/**
 * Propagates notifications that operations should be canceled.
 */
var CancellationToken = /*#__PURE__*/function () {
  /**
   * Creates a new CancellationToken linked to an existing CancellationTokenSource.
   * @param {CancellationTokenSource} source
   */
  function CancellationToken(source) {
    (0, _classCallCheck2.default)(this, CancellationToken);
    this.source = source;

    if (_freeze.default) {
      (0, _freeze.default)(this);
    }
  }
  /**
   * Gets a value indicating whether cancellation has been requested.
   * @property {boolean}
   */


  (0, _createClass2.default)(CancellationToken, [{
    key: "cancellationRequested",
    get: function get() {
      return this.source.cancellationRequested;
    }
    /**
     * Gets a value indicating whether the underlying source can be canceled.
     * @property {boolean}
     */

  }, {
    key: "canBeCanceled",
    get: function get() {
      return this.source.canBeCanceled;
    }
    /**
     * Throws a CancelError if cancellation has been requested.
     * @throws {CancelError}
     */

  }, {
    key: "throwIfCancellationRequested",
    value: function throwIfCancellationRequested() {
      if (this.cancellationRequested) {
        throw new _CancelError.default();
      }
    }
    /**
     * Registers a callback to execute when cancellation is requested.
     * @param {function(): void} The callback to register.
     * @returns {CancellationTokenRegistration}
     */

  }, {
    key: "register",
    value: function register(callback) {
      return this.source.register(callback);
    }
  }], [{
    key: "none",
    get:
    /**
     * Gets a token which will never be canceled.
     * @static
     * @property {CancellationToken}
     */
    function get() {
      var closedSource = new _CancellationTokenSource.default();
      closedSource.close();
      return new CancellationToken(closedSource);
    }
    /**
     * Gets a token that is already canceled.
     * @static
     * @property {CancellationToken}
     */

  }, {
    key: "canceled",
    get: function get() {
      var canceledSource = new _CancellationTokenSource.default();
      canceledSource.cancel();
      return new CancellationToken(canceledSource);
    }
  }]);
  return CancellationToken;
}();

var _default = CancellationToken;
exports.default = _default;